import * as React from 'react';

import AddNew from 'components/buttons/add-new/AddNew';

import { t } from 'utils/language';

import type { SyntheticEvent } from 'react';

type Props = {
  bucketsLength: number,
  onCreateBucket: (a: string) => void
};

class ContentApprovalAddLook extends React.PureComponent<Props> {
  handleAdd = (event: SyntheticEvent<HTMLElement>): void => {
    const { onCreateBucket } = this.props;
    const target = event.currentTarget;
    const title = target.dataset.title || '';

    if (title) {
      onCreateBucket(title);
    }
  };

  render(): React.ReactNode {
    const { bucketsLength } = this.props;

    return (
      <AddNew
        text={t('content_approval.add-btn')}
        size="xlarge"
        icon={{
          name: 'plus-inside-circle-custom-bg-white-fg',
          width: 24,
          height: 24
        }}
        onClick={this.handleAdd}
        data={{
          title: t('content_approval.buckets.looks.default_title', {
            index: bucketsLength + 1
          })
        }}
      />
    );
  }
}

export default ContentApprovalAddLook;
